module.exports = __webpack_public_path__ + "static/media/coinHashMarks.d3bbebca.svg";